export function formatError(template: string, args: Record<string, any>): string {
  let result = template;

  for (const key in args) {
    const value = args[key];
    result = template.replace('$' + key, value);
  }

  return result;
}